import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster, TooltipProvider } from '@vwt/ui';
import '@vwt/ui/styles.css';
import './lib/i18n.js';
import { queryClient } from './lib/api.js';
import { SessionProvider } from './lib/session.js';
import { router } from './app/router.js';

// Internal key links inside rendered Markdown navigate client-side.
document.addEventListener('click', (event) => {
  const anchor = (event.target as HTMLElement | null)?.closest('a[data-key-link="true"]') as HTMLAnchorElement | null;
  if (!anchor || event.metaKey || event.ctrlKey) return;
  event.preventDefault();
  void router.navigate(anchor.getAttribute('href')!);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <TooltipProvider>
          <RouterProvider router={router} />
          <Toaster position="bottom-right" richColors closeButton />
        </TooltipProvider>
      </SessionProvider>
    </QueryClientProvider>
  </StrictMode>,
);
